export default {
	Prayers: {
		SIGNUM_CRUCIS: 'In the name of the Father of the Son and of the Holy Spirit. Amen.',
		APOSTLES_CREED: 'I believe in God the Father Almighty, Creator of heaven and earth; and in Jesus Christ, His only Son, our Lord; Who was conceived by the Holy Ghost, born of the Virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried. He descended into hell. On the third day He arose again; He ascended into heaven,and sitteth at the right hand of God, the Father Almighty; from thence He shall come to judge the living and the dead. I believe in the Holy Ghost, the Holy Catholic Church, the communion of saints, the forgivness of sins, the resurrection of the body, and life everlasting. Amen.',
		PATER_NOSTER: 'Our Father, who art in heaven, hallowed be Thy name: Thy kingdom come: Thy will be done on earth as it is in heaven. Give us this day our daily bread: and forgive us our trespasses as we forgive those who trespass against us. Do not let us fall into temptation, but deliver us from evil. Amen.',
		AVE_MARIA: 'Hail Mary, full of grace, the Lord is with thee: blessed art thou among women, and blessed is the fruit of thy womb, Jesus. Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen.',
		GLORIA: 'Glory be to the Father, and to the Son and to the Holy Spirit. As it was in the beginning, is now and ever shall be, world without end. Amen.',
		ORATIO_FATIMA: 'O my Jesus, forgive us our sins, save us from the fires of hell, and lead all souls to Heaven, especially those in most need of Your Mercy.',
		SALVE_REGINA: 'Hail, holy Queen, Mother of Mercy! Our life, our sweetness, and our hope! To thee do we cry, poor banished children of Eve; to thee do we send up our sighs, mourning and weeping in this valley of tears. Turn, then, most gracious advocate, thine eyes of mercy toward us; and after this our exile show unto us the blessed fruit of thy womb, Jesus; O clement, O loving, O sweet Virgin Mary.'
	},

	Ordinals: {
		MYSTERY_1: 'First mystery',
		MYSTERY_2: 'Second mystery',
		MYSTERY_3: 'Third mystery',
		MYSTERY_4: 'Fourth mystery',
		MYSTERY_5: 'Fifth mystery'
	},

	Mysteries: {
		JOYFUL: {
			MYSTERY_1: 'The annunciation of the Lord to Mary',
			MYSTERY_2: 'The visitation of Mary to Elizabeth',
			MYSTERY_3: 'The nativity of our Lord Jesus Christ',
			MYSTERY_4: 'The presentation of our Lord',
			MYSTERY_5: 'Finding Jesus in the temple'
		},
		SORROWFUL: {
			MYSTERY_1: 'The agony of Jesus in the garden',
			MYSTERY_2: 'The scourging at the pillar',
			MYSTERY_3: 'Jesus is crowned with thorns',
			MYSTERY_4: 'Jesus carries the cross',
			MYSTERY_5: 'The crucifixion of our Lord'
		},
		GLORIOUS: {
			MYSTERY_1: 'The resurrection of Jesus Christ',
			MYSTERY_2: 'The ascension of Jesus to heaven',
			MYSTERY_3: 'The descent of the Holy Spirit',
			MYSTERY_4: 'The assumption of Mary into heaven',
			MYSTERY_5: 'Mary is crowned as queen of heaven and earth'
		},
		LUMINOUS: {
			MYSTERY_1: 'The baptism in the Jordan',
			MYSTERY_2: 'The wedding at Cana',
			MYSTERY_3: 'The proclamation of the Kingdom',
			MYSTERY_4: 'The transfiguration',
			MYSTERY_5: 'The institution of the Eucharist'
		}
	},

	Meditations: {
		JOYFUL: {
			MYSTERY_1: 'Behold the handmaid of the Lord; be it unto me according to thy word.',
			MYSTERY_2: 'And whence is this to me, that the mother of my Lord should come to me?',
			MYSTERY_3: 'For unto you is born this day in the city of David a Saviour, which is Christ the Lord.',
			MYSTERY_4: 'Behold, this child is set for a sign which shall be spoken against.',
			MYSTERY_5: 'And he said unto them, How is it that ye sought me? wist ye not that I must be about my Father\'s business?'
		},
		SORROWFUL: {
			MYSTERY_1: 'O my Father, if it be possible, let this cup pass from me.',
			MYSTERY_2: 'Then Pilate therefore took Jesus, and scourged him.',
			MYSTERY_3: 'Then came Jesus forth, wearing the crown of thorns, and the purple robe. And Pilate saith unto them, Behold the man!',
			MYSTERY_4: 'If any man will come after me, let him deny himself, and take up his cross, and follow me.',
			MYSTERY_5: 'Father, into thy hands I commend my spirit.'
		},
		GLORIOUS: {
			MYSTERY_1: 'Fear not ye: for I know that ye seek Jesus, which was crucified. He is not here: for he is risen, as he said. Come, see the place where the Lord lay.',
			MYSTERY_2: 'In my Father\'s house are many mansions: if it were not so, I would have told you. I go to prepare a place for you.',
			MYSTERY_3: 'And there appeared unto them cloven tongues like as of fire, and it sat upon each of them. And they were all filled with the Holy Ghost.',
			MYSTERY_4: 'Father, I will that they also, whom thou hast given me, be with me where I am.',
			MYSTERY_5: 'To him that overcometh will I grant to sit with me in my throne.'
		},
		LUMINOUS: {
			MYSTERY_1: 'And Jesus, when he was baptized ... and lo, a voice from heaven, saying, This is my beloved Son, in whom I am well pleased.',
			MYSTERY_2: 'His mother saith unto the servants, Whatsoever he saith unto you, do it.',
			MYSTERY_3: 'The time is fulfilled, and the kingdom of God is at hand: repent ye, and believe the gospel.',
			MYSTERY_4: 'And after six days Jesus taketh Peter, James, and John his brother, and bringeth them up into an high mountain apart, and was transfigured before them, and his face did shine as the sun, and his raiment was white as the light. And behold a voice out of the cloud, which said, This is my beloved Son, in whom I am well pleased; hear ye him.',
			MYSTERY_5: 'He riseth from supper, and laid aside his garments; and took a towel, and girded himself. After that he poureth water into a bason, and began to wash the disciples\' feet, and to wipe them with the towel wherewith he was girded.'
		}
	}
};
